import { AbstractPmsApiService } from "./abstract.service";
import { PropertyChannelDistribution } from "../models";

/**
 * @class PropertyChannelDistributionPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<PropertyChannelDistribution>}
 */
export class PropertyChannelDistributionPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/property-channel-distribution';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {PropertyChannelDistribution}
     * @protected
     */
    newModel(attributes, ...params) {

        return new PropertyChannelDistribution(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<PropertyChannelDistribution>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {PropertyChannelDistribution} settings
     * @returns {Promise.<PropertyChannelDistribution>}
     */
    save(property, settings) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, settings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    refresh(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url + '/refresh', {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/property-channel-distribution.service.js